<template>
  <div class="CodeLogin">
    <div class="CodeTextStyle">
      验证码登录
    </div>
    <div class="CodeInput">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="ruleForm">
        <input type="text" v-model="ruleForm.userName" placeholder="请输入手机号" class="userNameCss" />
        <input type="password" v-model="ruleForm.password" placeholder="请输入验证码" class="passWordCss" />
        <div class="CodeBtn" @click="CodeClick" v-if="CodeFlag">发送验证码</div>
        <div class="CodeBtnTime" v-else>重新获取（{{ Second }}s）</div>
        <div @click="onSubmit" class="btn-OK-submit">登录</div>
      </el-form>
    </div>
  </div>
</template>

<script>
import LoginCodeListRules from "../LoginFromList/LoginCodeList-rules"
export default {
  data: function () {
    return {
      CodeFlag: true,
      Timer: null, //计时器
      Second: "", //倒计时秒
      ruleForm: {
        userName: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      }
    }
  },
  created() {
    this.EnterKeyDown()
  },
  mounted() {
    this.rules = JSON.parse(JSON.stringify(LoginCodeListRules))
  },
  methods: {
    // 回车登录
    EnterKeyDown() {
      let that = this
      document.onkeydown = function (e) {
        if (that.$route.query.PageState == 1) {
          if (e.keyCode == 13) {
            //console.log('CodeLogin');
          }
        }
      }
    },
    // 获取验证码
    CodeClick() {
      this.CodeFlag = false
      const TIME_COUNT = 60; //倒计时秒
      if (!this.Timer) {
        this.Second = TIME_COUNT
        this.Timer = setInterval(() => {
          if (this.Second > 0 && this.Second <= TIME_COUNT) {
            this.Second--
          } else {
            this.CodeFlag = true;
            clearInterval(this.Timer)
            this.Timer = null
          }
        }, 1000)
      }
    },
    // 登录事件
    async onSubmit() {
      //   const loading = this.$loading({
      //     lock: true,
      //     text: '登录中...',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(255,255,255,0.3)'
      //   });
      //   let reslogin = await Login({
      //     userName: this.ruleForm.userName,
      //     password: this.$md5(this.ruleForm.password).toUpperCase()
      //   })
      //   if (reslogin.code == 0) {
      //     this.error = ""

      //     this.$message({
      //       type: 'success',
      //       message: '登录成功'
      //     });
      //     const startTime = new Date().getTime()
      //     // 保存登录时间
      //     localStorage.setItem("token-startTime", startTime)
      //     this.$store.commit("SET_TOKEN", reslogin.data.Token)
      //     this.$store.commit("SET_USERINFO", reslogin.data.user)
      //     this.userInfoMun()
      //     this.$router.push({
      //       path: '/homePage'
      //     });
      //     loading.close();

      //   } else {
      //     this.error = reslogin.message
      //     loading.close();
      //   }
    },
  }

}
</script>

<style lang='less' scoped>
.CodeLogin {
  //   border: 1px solid black;
  width: 89%;
  padding: 20px;

  .CodeTextStyle {
    height: 90px;
    // border: 1px solid rebeccapurple;
    font-weight: bold;
    color: #424e66;
    line-height: 90px;
    font-size: 20px;
    padding-left: 40px;
  }

  .CodeTextStyle::before {
    content: "";
    background: url("../../../assets/channel/login/leftLogin.png") no-repeat 0px
      0px;
    position: absolute;
    top: 120px;
    left: 15px;
    // border: 1px solid red;
    width: 39px;
    height: 16px;
  }
  .CodeInput {
    .userNameCss {
      width: 320px;
      height: 40px;
      border: 1px solid #e6e8eb;
      background: #fafbfc;
      border-radius: 2px;
      font-size: 14px;
      padding-left: 10px;
    }
    .passWordCss {
      width: 184px;
      height: 40px;
      border: 1px solid #e6e8eb;
      background: #fafbfc;
      border-radius: 2px;
      font-size: 14px;
      padding-left: 10px;
      margin-top: 20px;
    }

    .btn-OK-submit {
      width: 100%;
      height: 40px;
      background-color: #e71d43;
      text-align: center;
      font-size: 14px;
      color: #fff;
      font-family: "微软雅黑";
      border-radius: 2px;
      margin-top: 20px;
      line-height: 40px;
    }
    .CodeBtn {
      display: inline-block;
      width: 120px;
      height: 40px;
      background-color: #e71d43;
      text-align: center;
      font-size: 14px;
      line-height: 40px;
      color: #fff;
      font-family: "微软雅黑";
      border-radius: 2px;
      margin-left: 15px;
      cursor: pointer;
      user-select: none;
    }
    .CodeBtnTime {
      display: inline-block;
      width: 120px;
      height: 40px;
      line-height: 40px;
      background-color: #ced3d9;
      text-align: center;
      font-size: 14px;
      color: #ffffff;
      font-family: "微软雅黑";
      border-radius: 2px;
      margin-left: 15px;
      cursor: pointer;
      user-select: none;
    }
  }
}
</style>